var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"language-switch",on:{"click":_vm.switchLanguage}},[_vm._v(_vm._s(_vm.currentLanguage === 'en' ? 'DE' : 'EN'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }